<template>
  <div>
    <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item">
              <a-form-item :label-col="{ span: 8 }" label="起止日期">
                <a-range-picker
                  @change="onChangeTime"
                  :placeholder="['开始日期', '结束日期']"
                  :disabled-date="disabledDate"
                  :disabled="disabledAll"
                  v-decorator="[
                    'ployordTime',
                    {
                      rules: [{ required: true, message: '请选择起始日期！' }],
                    },
                  ]"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [
                      moment('00:00:00', 'HH:mm:ss'),
                      moment('23:59:59', 'HH:mm:ss'),
                    ],
                  }"
                />
                <span style="margin-left: 24px" v-if="planOffsetDay > 0"
                  >共{{ planOffsetDay }}天</span
                >
              </a-form-item>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <div class="flex_">
          <!-- 工程造价（元） -->
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="工程造价（元）">
              <a-input
                :disabled="disabledAll"
                style="width: 280px"
                v-model="countData.GCZJ"
                @change="(e) => changeData(e.target.value, 'GCZJ')"
                placeholder="请填写工程造价"
                v-decorator="[
                  'countData.GCZJ',
                  {
                    rules: [{ required: true, message: '请输入工程造价金额' }],
                  },
                ]"
              ></a-input>
            </a-form-item>
          </div>
          <!-- 第三者责任限额（元） -->
          <div class="form_item">
            <a-form-item
              :label-col="{ span: 10 }"
              label="第三者责任限额（元）"
              class="aftertext"
            >
              <a-input
                :disabled="disabledAll"
                style="width: 280px"
                v-model="countData.DSZRXE"
                @blur="(e) => changeData(e.target.value, 'DSZRXE')"
                placeholder="请填写金额"
                v-decorator="[
                  'countData.DSZRXE',
                  {
                    rules: [
                      { required: true, message: '请输入第三者责任限额' },
                      { validator: checkPrice },
                    ],
                  },
                ]"
              ></a-input>
            </a-form-item>
          </div>
          <!-- 每人赔偿限额 -->
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="每人赔偿限额">
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                @change="(value) => changeData(value, 'everyPrice')"
                v-decorator="[
                  'countData.everyPrice',
                  {
                    rules: [{ required: true, message: '请选择每人赔偿限额' }],
                  },
                ]"
              >
                <a-select-option
                  v-for="item in oneSCOptions"
                  :key="item.value + 'everyPrice'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
          <!-- 工程类型 -->
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="工程类型">
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                @change="(value) => changeData(value, 'GCTYPE')"
                v-decorator="[
                  'countData.GCTYPE',
                  {
                    rules: [{ required: true, message: '请选择工程类型' }],
                  },
                ]"
              >
                <a-select-option
                  v-for="item in gogncOptions"
                  :key="item.value + 'GCTYPE'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
          <!-- 投保须知 -->
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="免费扩展条款：">
              <div style="margin-top: 10px">
                <div
                  class="tiaokuan_list"
                  v-for="(item, index) of tuozanArr"
                  :key="index"
                >
                  {{ index + 1 }}. {{ item }}
                </div>
              </div>
            </a-form-item>
          </div>
        </div>
        <div class="btn_list">
          <a-button
            class="calBtn_"
            type="primary"
            @click="countPremiumSum"
            :disabled="disabledAll"
            >刷新试算</a-button
          >
          <a-button
            style="margin-bottom: 50px"
            class="calBtn_"
            type="primary"
            v-if="!agreementRead"
            @click="goplicy"
            :disabled="disabledAll"
            >去投保</a-button
          >
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
    mixins: [riskinfoMixin],
  data() {
    return {
      allData: {},
      form: this.$form.createForm(this, { name: "advanced_search" }),
      tuozanArr: [
        "罢工、暴动或民众骚乱扩展条款",
        "自动恢复保险金额条款",
        "专业费用扩展条款（赔偿限额：保险金额的5%）",
        "清除残骸费用扩展条款（赔偿限额：保险金额的5%）",
        "特别费用扩展条款（赔偿限额：损失金额的10%）",
        "灭火费用扩展条款（每次及累计赔偿限额：RMB200,000.00）",
        "责任保证期扩展条款 （保证期限：6 个月）",
        "承租人责任条款",
        "交叉责任扩展条款",
        "放弃代位追偿扩展条款",
        "震动、移动或减弱支撑扩展条款",
        "错误和遗漏条款",
        "不受控制条款",
        "不使失效条款",
      ],
      premiumSum: 0, //总保费
      gogncOptions: [
        {
          value: "shop",
          name: "商铺/办公室室内装修",
        },
        {
          value: "residential",
          name: "住宅室内装修",
        },
      ],
      planOffsetDay: 0,
      ployordTime: [], //保单时间
      effectiveDate: "", // 保单生效时间
      expireDate: "", //保单终止时间
      // 测算要提交的数据
      countData: {
        GCZJ: undefined, //工程造价
        DSZRXE: undefined, //第三责任限额
        everyPrice: undefined, //每人赔偿限额
        GCTYPE: undefined, //工程类型
      },
      //提交data
      data: {},
      planType: "A",
      creator: "1",
      productCode: "",
      plan: "",
      userParams: "",
    };
  },
  computed: {
    // 工伤伤残赔付高标准（附加提升伤残比例）
    oneSCOptions() {
      let options = [
        {
          value: '1',
          name: "同每次事故限额",
        },
        {
          value: 200000,
          name: "20万",
        },
        {
          value: 500000,
          name: "50万",
        },
      ];
      if (this.countData.DSZRXE == 500000) {
        return options.filter((item) => item.value < 500000);
      }
      return options;
    },
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: "projectamount", //工程造价（元）
          amount: this.countData.GCZJ,
        },
        {
          riskCode: "thirdLimit", //第三者责任限额（元）
          amount: this.countData.DSZRXE,
        },
        {
          riskCode: "avoirdupois", //每人赔偿限额
          amount: this.countData.everyPrice,
        },
        {
          riskCode: "projectType", //工程类型
          dutyCode: this.countData.GCTYPE,
        },
      ];
      return infos;
    },
  },
  watch: {},
  props: ["disabledAll"],
  created() {
    const { u, p,planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode;
    this.userParams = {
      //从地址中获取
      userId: u,
      productCode: p,
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    moment,
    busOnDataMethod() {
      let data = this.$lodash.cloneDeep(this.$parent.$refs.salInsuredList.formData);
      
      this.form.setFieldsValue({
        countData: {
          GCZJ: data.salPolicyHolder.projectamount,
          DSZRXE: data.salPolicyHolder.thirdLimit,
          everyPrice: data.salPolicyHolder.avoirdupois || undefined,
          GCTYPE:
            data.riskInfos.filter((item) => item.riskCode == "projectType")[0]
              .dutyCode || undefined,
        },
      });
      
      if (data.salPolicy.effectiveDate && data.salPolicy.expireDate) {
        this.form.setFieldsValue({
          ployordTime: [
            moment(data.salPolicy.effectiveDate, "YYYY-MM-DD"),
            moment(data.salPolicy.expireDate, "YYYY-MM-DD"),
          ],
        });
        this.ployordTime = [
          moment(data.salPolicy.effectiveDate, "YYYY-MM-DD"),
          moment(data.salPolicy.expireDate, "YYYY-MM-DD"),
        ];
      }
      this.$nextTick(()=>{
        this.countData.GCZJ = data.salPolicyHolder.projectamount;
        this.countData.DSZRXE = data.salPolicyHolder.thirdLimit;
        this.countData.everyPrice = data.salPolicyHolder.avoirdupois || undefined;
        this.countData.GCTYPE =
          data.riskInfos.filter((item) => item.riskCode == "projectType")[0]
            .dutyCode || undefined;
      })
    },
    // applicantInfoExpireDate() {
    //   var year = new Date().getFullYear(); //获取当前日期的年份
    //   var month = new Date().getMonth(); //获取当前日期的月份
    //   var day = new Date().getDate(); //获取当前日期的日
    //   var days = new Date(year, month, 0);
    //   days = days.getDate(); //获取当前日期中的月的天数
    //   var year2 = year;
    //   var month2 = parseInt(month) + parseInt(12);
    //   if (month2 > 12) {
    //     year2 =
    //       parseInt(year2) +
    //       parseInt(parseInt(month2) / 12 == 0 ? 1 : parseInt(month2) / 12);
    //     month2 = parseInt(month2) % 12;
    //   }
    //   var day2 = day - 1;
    //   var days2;
    //   if (day2 == 0) {
    //     month2 = month2 - 1;
    //     days2 = new Date(year2, month2, 0);
    //     day2 = days2.getDate();
    //   } else {
    //     days2 = new Date(year2, month2, 0);
    //   }
    //   days2 = days2.getDate();
    //   if (day2 > days2) {
    //     day2 = days2;
    //   }
    //   if (month2 < 10) {
    //     month2 = "0" + month2;
    //   }

    //   var t2 = year2 + "-" + month2 + "-" + day2 + " " + "23:59:59";
    //   if (!year2 || !month2 || !day2) {
    //     return null;
    //   }
    //   return this.moment(t2, "YYYY/MM/DD HH:mm:ss");
    // },
    //校验第三责任金额
    checkPrice(rule, value, callback) {
      if (value >= 500000) {
        callback();
        return;
      }
      callback("第三者责任限额最低50万起保!");
    },
    onChangeTime(value, dateString) {
      
      
      this.ployordTime = dateString;
      this.effectiveDate = value[0]; // 保单生效时间
      this.expireDate = value[1]; //保单终止时间
      let end = moment(value[1]).subtract(0, "days");
      let offsetDay = end.diff(value[0], "days");
      this.planOffsetDay = offsetDay;
      this.changeData();
    },
    disabledDate(current) {
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + "-" + m + "-" + d;
      var currents = moment(time);
      return current < currents || current > moment(currents).add(1, "year");
    },
    // 去投保
    goplicy() {
      this.$store.commit("setAgreement", true);
      this.$parent.$refs.salInsuredList.resultPremiumSum();
    },
    // 改变试算的数据
    changeData(value, param){
      
      if (!value||!param) return
      this.countData[param] = value;
      this.data = {
        riskInfos: this.riskInfos,
        salPolicy: {
          planCode: this.plan,
          creator: this.creator,
          productCode: "YTJGYQX", //产品code
          effectiveDate: this.effectiveDate ? new Date(this.effectiveDate) : "",
          expireDate: this.expireDate ? new Date(this.expireDate) : "",
        },
        salPolicyExt: {
          isworkheightinvolved: "2",
        },
        salPolicyHolder: {
          addfifty: "2", // 测算类型
          stature: "2", //是否高空（2-否，1-是）
          projectamount: this.countData.GCZJ,
          thirdLimit: this.countData.DSZRXE,
          avoirdupois: this.countData.everyPrice,
        },
      };
      let arrData = this.$lodash.cloneDeep(this.data);
      if (
        Number(this.countData.GCZJ || 0) + Number(this.countData.DSZRXE || 0) >
        30000000
      ) {
        this.$message.warning("本产品工程造价+三责限额，累计不得超过3000万元!");
        this.$nextTick(() => {
          this.form.setFieldsValue({
            countData: {
              DSZRXE: undefined,
            },
          });
          this.countData.DSZRXE = undefined;
        });
        return;
      }
      
      this.allData = arrData;
      if (this.$parent.$refs.salInsuredList) {
        this.$parent.$refs.salInsuredList.busDataMethod();
      }
    },
    //保费试算
    countPremiumSum(e) {
      e.preventDefault();
      this.changeData();
      let formData = this.$lodash.cloneDeep(this.data);
      if (this.countData.DSZRXE < 500000) {
        this.$message.error("第三者责任限额50万起保", 3);
        return;
      }
      this.form.validateFields((err) => {
        if (!err) {
          
          this.$api.calPremiumEmployer(formData).then((res) => {
            if (res.data.success) {
              if (res.data.content && res.data.content > 0) {
                if (res.data.content < 500) {
                  this.$message.warning("本产品最低收费500元!");
                  this.premiumSum = 500;
                } else {
                  this.premiumSum = res.data.content;
                }
              }
            } else {
              this.$message.error(res.data.returnMsg + "错误");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .policy {
    display: none;
  }

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}

.form_item {
  margin-bottom: 0;
  .ant-form-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.aftertext {
  position: relative;
}
.aftertext::after {
  content: "500000元起保";
  position: absolute;
  color: #999999;
  top: 10px;
  right: 30px;
  z-index: 2;
}
.tiaokuan_list {
  line-height: 24px;
}
</style>